import { SET_ZOHO_POPUP } from "./zoho-action-types";

export interface IZohoPopupState {
    isOpen: boolean;
    id: number;
    version: number;
    sizeErrorOpen: boolean;
    size: 0;
}

const initialState: IZohoPopupState = {
    isOpen: false,
    sizeErrorOpen: false,
    id: 0,
    version: 0,
    size: 0,
};

const ZohoPopupReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ZOHO_POPUP:
            if (action.size > 10 * 1024) {
                return {
                    ...state,
                    sizeErrorOpen: true,
                };
            }

            return {
                ...state,
                sizeErrorOpen: false,
                isOpen: action.isOpen,
                id: action.id,
                version: action.version,
            };

        default:
            return state;
    }
};

export default ZohoPopupReducer;
